const equalityArray = (array1, array2) => (array1.toString() === array2.toString());

export {
  equalityArray,
};
